import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_PATCH } from '../../constants/api';

export const setArticles = createAction('articles/setArticles');
export const clearArticlesUpdate = createAction('articles/clearArticlesUpdate');

const patchArticles = createAsyncThunk('articles/patchArticles',
  async ({ id, ...patchData }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_PATCH, `/articles/${id}`, patchData);
      dispatch(setArticles(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchArticles;
